/* global __CLIENT__*/
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { List, Map } from 'immutable';
import immutableCreatorSelector from '../selectors/immutableCreatorSelector';

import { currentUserSelector } from '../reducers/users';
import { ProjectActions } from '../actions/project';

import ProjectCardsContainer from './ProjectCardsContainer';
// import { ProjectCards } from './ProjectCardsContainer';

class AccountProjects extends PureComponent {
  static propTypes = {
    projects: PropTypes.oneOfType([
      PropTypes.instanceOf(List),
      PropTypes.instanceOf(Map),
      PropTypes.instanceOf(Set),
    ]),
    accountId: PropTypes.string,
    currentUser: PropTypes.instanceOf(Map),
    users: PropTypes.instanceOf(Map),
  };

  // isUnassignedButAccAdmin = (projectId, currentUserId) => {
  //   const { accountId, users, currentUser } = this.props;
  //   if (!accountId) return false;
  //   const isAccountAdmin =
  //     users.getIn([currentUserId, 'roles', 'account', accountId]) <= 2;
  //   const isAssignedToProject = currentUser.getIn([
  //     'roles',
  //     'project',
  //     projectId,
  //   ]);

  //   return isAccountAdmin && !isAssignedToProject;
  // };

  // sortProjects = () => {
  //   const { projects, currentUser } = this.props;

  //   if (!projects || !projects.size) return;

  //   const assigned = [];
  //   const unassigned = [];

  //   projects
  //     .sort((a, b) => b.get('id') - a.get('id'))
  //     .forEach(v => {
  //       const isUnassignedButAccAdmin = this.isUnassignedButAccAdmin(
  //         v.get('id'),
  //         currentUser.get('id'),
  //       );

  //       console.log('unassigned?', v.get('id'), v.get('name'), isUnassignedButAccAdmin);

  //       if (isUnassignedButAccAdmin) {
  //         unassigned.push(v);
  //       } else {
  //         assigned.push(v);
  //       }
  //     });

  //   debugger;
  //   const projectsList = List(assigned.concat(unassigned));
  //   return projectsList;
  // }

  render() {
    const { projects, accountId } = this.props;

    // const sortedProjects = this.sortProjects();
    // console.log('account projects', projects.toList());
    return (
      <ProjectCardsContainer
        projects={projects.toList()}
        accountId={accountId}
        deleteRedirect={false}
      />
    );
  }
}

const usersSelector = state => state.users.get('users');
const currentAccountProjectsSelector = (state, props) => {
  const accountId = props.params.accountId;
  const projectIds = state.accounts
    .getIn(['projects', accountId], List())
    .toList();
  return projectIds.map(projectId => {
    return state.projects.getIn(['projects', projectId]);
  });
};

const AccountProjectsContainerSelector = immutableCreatorSelector(
  [currentAccountProjectsSelector, currentUserSelector, usersSelector],
  (projects, currentUser, users) => {
    return {
      projects,
      currentUser,
      users,
    };
  },
);

@connect(AccountProjectsContainerSelector)
export default class AccountProjectsContainer extends PureComponent {
  static propTypes = {
    dispatch: PropTypes.func,
    params: PropTypes.object,
    projects: PropTypes.oneOfType([
      PropTypes.instanceOf(List),
      PropTypes.instanceOf(Map),
      PropTypes.instanceOf(Set),
    ]),
  };

  componentDidMount() {
    const {
      params: { accountId },
      dispatch,
    } = this.props;
    dispatch(ProjectActions.getProjects(accountId));

    // const { dispatch, params: { accountId }, projects } = this.props;

    // if (projects.size === 0) {
    // dispatch(ProjectActions.getProjects(accountId));
    // }
  }

  render() {
    const {
      projects,
      params: { accountId },
    } = this.props;
    if (projects.size === 0) return <span />;

    return <AccountProjects {...this.props} accountId={accountId} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/AccountProjects.js